export default class WorkflowNodeErrorDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate) });
    }
}
